// Shares the useAgentChat session between the chat column and the canvas in agentic mode.
import { createContext, useContext, type ReactNode } from 'react'
import { useAgentChat, type UseAgentChatReturn } from './hooks/useAgentChat'

const AgentSessionContext = createContext<UseAgentChatReturn | null>(null)

interface AgentSessionProviderProps {
    children: ReactNode
}

export function AgentSessionProvider({ children }: AgentSessionProviderProps) {
    const session = useAgentChat()
    return (
        <AgentSessionContext.Provider value={session}>
            {children}
        </AgentSessionContext.Provider>
    )
}

export function useAgentSession(): UseAgentChatReturn {
    const ctx = useContext(AgentSessionContext)
    if (!ctx) {
        throw new Error(
            'useAgentSession must be used inside an <AgentSessionProvider>',
        )
    }
    return ctx
}
